export const STATUS_MESSAGES = {
    TRIAGEM_INICIADA: 'Triagem iniciada com sucesso',
    ENCAMINHADA_CONTRATACAO: 'Demanda encaminhada para contratação com sucesso',
    DEMANDA_ACEITA: 'Demanda aceita pelo profissional com sucesso',
    DEMANDA_RECUSADA: 'Demanda recusada pelo profissional com sucesso',
    EXECUCAO_INICIADA: 'Execução iniciada com sucesso',
    DEMANDA_CONCLUIDA: 'Demanda concluída com sucesso',
    DEMANDA_INTERROMPIDA: 'Demanda interrompida com sucesso',
    DEMANDA_FINALIZADA: 'Demanda finalizada com sucesso',
    EXECUCAO_REABERTA: 'Demanda reaberta para contratação com sucesso',
    DEMANDA_CANCELADA: 'Demanda cancelada com sucesso',
    ERRO_TRIAGEM: 'Erro ao iniciar triagem',
    ERRO_ENCAMINHAR: 'Erro ao encaminhar para contratação',
    ERRO_ACEITAR: 'Erro ao aceitar demanda',
    ERRO_RECUSAR: 'Erro ao recusar demanda',
    ERRO_INICIAR_EXECUCAO: 'Erro ao iniciar execução',
    ERRO_CONCLUIR: 'Erro ao concluir demanda',
    ERRO_INTERROMPER: 'Erro ao interromper demanda',
    ERRO_FINALIZAR: 'Erro ao finalizar demanda',
    ERRO_REABRIR: 'Erro ao reabrir demanda para contratação',
    ERRO_CANCELAR: 'Erro ao cancelar demanda'
} as const;

